export class DisplayOption {
  constructor(
    public readonly value: string | number,
    public readonly displayText: string
  ) {}

  toString() {
    return this.displayText;
  }
}
